import '../../css/pages/map.css';
import { initShell } from '../lib/shell';

initShell();

interface MapPoint {
  id: string;
  x: number;
  y: number;
  category: string;
  scene: string | null;
  label: string;
  description: string;
}

declare global {
  interface Window {
    __MAP__?: { base_image: string; points: MapPoint[] };
    __MAP_SCENES__?: { id: string; href: string }[];
  }
}

const data = window.__MAP__;
const sceneHrefs = new Map((window.__MAP_SCENES__ ?? []).map((s) => [s.id, s.href]));
const pointsEl = document.getElementById('map-pins');
const listEl = document.getElementById('map-list');
const ctaBtn = document.getElementById('map-360-btn') as HTMLAnchorElement | null;
const defaultCtaHref = ctaBtn?.getAttribute('href') ?? '#';

if (data && pointsEl) {
  const markers = new Map<string, HTMLElement>();

  function setActive(pointId: string | null): void {
    for (const [id, el] of markers) {
      el.classList.toggle('is-active', id === pointId);
    }
    for (const item of listEl?.querySelectorAll<HTMLElement>('.map-list__item') ?? []) {
      const point = pointId ? data!.points.find((p) => p.id === pointId) : null;
      item.classList.toggle('is-active', !!point && item.dataset.scene === point.scene);
    }
    if (ctaBtn) {
      const point = pointId ? data!.points.find((p) => p.id === pointId) : null;
      const href = (point?.scene && sceneHrefs.get(point.scene)) || defaultCtaHref;
      ctaBtn.setAttribute('href', href);
    }
  }

  // ---- Render map pins ------------------------------------------------
  for (const p of data.points) {
    const marker = document.createElement('button');
    marker.type = 'button';
    marker.className = 'map-marker';
    marker.dataset.category = p.category;
    if (p.scene) marker.dataset.scene = p.scene;
    marker.style.left = p.x + '%';
    marker.style.top = p.y + '%';
    marker.innerHTML = `<span class="map-marker__label">${p.label}</span><span class="map-marker__pin"></span>`;
    marker.setAttribute('aria-label', p.label);
    marker.addEventListener('click', (e) => {
      e.stopPropagation();
      setActive(p.id);
      if (p.scene && sceneHrefs.get(p.scene)) {
        window.location.href = sceneHrefs.get(p.scene)!;
      }
    });
    pointsEl.appendChild(marker);
    markers.set(p.id, marker);
  }

  document.getElementById('map-canvas')?.addEventListener('click', () => setActive(null));

  // ---- Scene list <-> map pin cross-highlight --------------------------
  for (const item of listEl?.querySelectorAll<HTMLElement>('.map-list__item') ?? []) {
    const sceneId = item.dataset.scene;
    if (!sceneId) continue;
    const point = data.points.find((p) => p.scene === sceneId);
    if (!point) continue;
    item.addEventListener('mouseenter', () => setActive(point.id));
    item.addEventListener('focus', () => setActive(point.id));
  }
}
